export default "__VITE_PUBLIC_ASSET__093b755e__"